<template>
  <div>
    <!-- 增加 -->
    <el-button type="primary" @click="add()" class="add">添加</el-button>
    <!-- 关键词和分类查询 -->
    <div class="search">
      <el-input v-model="keyword" placeholder="请输入关键字" class="keyword"></el-input>
      <el-select v-model="newsort" placeholder="请选择">
        <el-option label="全部栏目" value="-1"></el-option>
        <el-option v-for="item in menu" :key="item.id" :label="item.title" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="search()">搜索</el-button>
    </div>
    <!-- 列表显示 -->
    <el-table :data="list" style="width: 100%" border stripe>
      <el-table-column prop="title" label="标题"></el-table-column>
      <!--      <el-table-column label="图片">-->
      <!--        <template slot-scope="scope">-->
      <!--          <img :src="scope.row.img" alt class="conimg"/>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column prop="intro" label="简介"></el-table-column>
      <el-table-column prop="create_time" label="日期"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-size="pagination.pageSize"
      layout="total,  prev, pager, next, jumper"
      :total="pagination.total"
      :hide-on-single-page="true"
    ></el-pagination>
    <!-- 具体内容 -->
    <el-dialog title="内容编辑" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="所属分类">
          <el-select v-model="form.dynamic_id" placeholder="请选择">
            <el-option v-for="item in menu" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="form.create_time"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
<!--        <el-form-item label="上传图片">-->
<!--          <el-upload-->
<!--            class="upload-demo"-->
<!--            action="/api/uploader"-->
<!--            :show-file-list="false"-->
<!--            :on-success="success"-->
<!--            :headers="headers"-->
<!--          >-->
<!--            <el-button size="small" type="primary">点击上传</el-button>-->
<!--          </el-upload>-->
<!--          <div class="upimg">-->
<!--            <img v-if="form.img" :src="form.img" alt width="300"/>-->
<!--          </div>-->
<!--        </el-form-item>-->
        <el-form-item label="简介">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.intro"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <vue-ueditor-wrap v-model="form.content" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {
            id: 1,
            title: "新闻1",
            img: "http://res.sjzqcrl.com/case1.png",
            time: "2019-10-22",
            browse: "5",
            intro: "简单介绍一文本的具体内容，具体不会超多200字"
          }
        ],
        dialogVisible: false,
        menu: [],
        form: {
          id: 0,
          dynamic_id: '',
          title: "",
          intro: 1,
          img: "http://res.sjzqcrl.com/case1.png",
          content: "",
          create_time: ""
        },
        newsort: "-1",
        keyword: "",
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 100
        },
        headers: {
          token: window.sessionStorage.getItem("token")
        },
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 240,
          // 初始容器宽度
          initialFrameWidth: "100%",
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          serverUrl:
            "/api/uploaders?token="+window.sessionStorage.getItem("token"),
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: "/static/UEditor/"
        },
      };
    },
    methods: {
      //数据初始化
      async getarticle(val) {
        var dt = await this.$axios.post('/api/news', {
          menu: this.newsort,
          search: this.keyword,
          page: val
        })
        dt.data = JSON.parse(dt.data)
        console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code != 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.list = dt.data.data.list.data
        this.menu = dt.data.data.menu
        this.pagination.currentPage = dt.data.data.list.current_page
        this.pagination.total = dt.data.data.list.total
        this.pagination.pageSize = dt.data.data.list.per_page
      },
      //请求单挑数据
      async handleEdit(val) {
        this.dialogVisible = true;
        var dt = await this.$axios.post('/api/getnews', {
          newsid: val.id
        })
        dt.data = JSON.parse(dt.data)
        // console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.form = dt.data.data
      },
      //删除数据
      async handleDelete(val) {
        var dt = await this.$axios.post('/api/deletenews',{
          id:val.id
        })
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          } else {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        } else {
          alert(dt.statusText)
          return;
        }
        if(this.list.length==1){
          this.getarticle(this.pagination.currentPage-1)
        }else{
          this.getarticle(this.pagination.currentPage)
        }
      },
      //图片上传成功的回调函数
      success(response, file, fileList) {
        this.form.img = response.data.url
      },
      //增加
      add() {
        this.form.id = 0;
        this.form.dynamic_id = '';
        this.form.title = '';
        this.form.intro = '';
        this.form.img = '';
        this.form.content = '';
        this.form.create_time = '';
        this.dialogVisible = true;
      },
      //搜索
      search() {
        this.getarticle(this.pagination.currentPage)
      },
      //保存
      async save() {
        // console.log(new Date(this.form.create_time))
        var dt = await this.$axios.post('/api/amendnews', this.form)
        dt.data = JSON.parse(dt.data)
        // console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          } else {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.dialogVisible = false;
        this.form.id = 0;
        this.form.dynamic_id = '';
        this.form.title = '';
        this.form.intro = '';
        this.form.img = '';
        this.form.content = '';
        this.form.create_time = '';
        this.getarticle(this.pagination.currentPage)
      },
      //分页切换
      handleCurrentChange(val) {
        this.getarticle(val)
      }
    },
    created() {
      this.getarticle(1)
    }
  };
</script>

<style lang="less" scoped>
  .add {
    margin-bottom: 20px;
  }

  .conimg {
    width: 35%;
  }

  .keyword {
    width: 20%;
  }

  .search {
    margin-bottom: 20px;
  }

  .upimg {
    margin-top: 20px;
    width: 250px !important;

    img {
      width: 100%;
    }
  }

  .el-pagination {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/article.vue